import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { getLoggedInUser } from '../authentication/userCreators';

export function updateUserDefaultPage(defaultPage) {
  return function(dispatch, getState) {
    // get the logged in user first, otherwise we might have dateUpdated conflicts
    dispatch(getLoggedInUser()).then(
      user => {
        const endpoint = '/user/current';
        const options = {
          method: "PUT",
          headers: { token: getState().authentication.token },
          params: { productId: config.productId },
          data: {
            defaultPage,
            dateUpdated: user.dateUpdated
          }
        };
        return makeAPICall(endpoint, options).then(
          response => {
            // finally, reUpdate the logged in user
            dispatch(getLoggedInUser());
            return response;
          },
          error => dispatch(APIError(error, 'Error updating Logged In User'))
        );
      }
    )
  };
}



// WEBPACK FOOTER //
// ./src/actions/users/settingsCreators.js